"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hashed;

function hashed(o) {
  return Object.getOwnPropertyNames(o).map(function (prop) {
    return "".concat(prop, "=").concat(encodeURIComponent(o[prop]));
  }).join('&');
}